"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = __importDefault(require("./styles"));
const FilledSVG = ({ id, children, fill, fillColor, stopColor = 'transparent', }) => {
    const classes = styles_1.default();
    return (react_1.default.createElement("svg", { className: classes.icon },
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { gradientUnits: "userSpaceOnUse", id: id, x1: "10", y1: "20", x2: "10", y2: "0" },
                react_1.default.createElement("stop", { offset: `${fill}%`, stopColor: fillColor }),
                react_1.default.createElement("stop", { offset: "0%", stopColor: stopColor }))),
        react_1.default.createElement("svg", { fill: `url(#${id})` }, children)));
};
exports.default = FilledSVG;
